import React, { FunctionComponent } from 'react';
import { breakpoints, Button, ButtonProps } from '@ds/ui';
import { inkSpacingTokens } from '@ds/tokens';
import { TranslationContext } from '@ds/react-utils';
import styled from '@emotion/styled';
import breakpointSizes from 'layouts/ApplicationLayout/objects/breakpointSizes/breakpointSizes';

const ContainerLayoutFooterPrimaryButtonContainer = styled.div`
    margin-left: ${inkSpacingTokens.spacingXS};

    // MOBILE
    ${breakpoints.lessThan(breakpointSizes.xs)} {
        margin-left: inherit;
    }
`;

const ContainerLayoutFooterPrimaryButton: FunctionComponent<ButtonProps> = props => {
    const translate = React.useContext(TranslationContext);

    return (
        <ContainerLayoutFooterPrimaryButtonContainer>
            <Button data-qa="sticky-button-primary" kind="primary" size="small" text={translate('button-next-titlecase')} {...props} />
        </ContainerLayoutFooterPrimaryButtonContainer>
    );
};

export default ContainerLayoutFooterPrimaryButton;
